// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/customPage/investment-advisor/Pages/BaseInfo.scss
// module id = 4153
// module chunks = 50